import {CheckSuccessIcon} from '../../asset/image'
import {selectTheme} from '../../store'
import {ButtonCancel, LabelBox, TextLink, Textarea, Button, PopupTemplate, PopupSize} from '..'

interface PopupSendNotificationSucceedProps {
  messageTitle: string
  messageContent: string
  closeAction: () => void
  zIndex?: number
}

export const PopupSendNotificationSucceed = (props: PopupSendNotificationSucceedProps) => {
  const {fontSize, fontWeight} = selectTheme()
  const {messageTitle, messageContent, closeAction, zIndex} = props

  return (
    <PopupTemplate
      {...{
        title: (
          <div css={{display: 'flex', alignItems: 'center'}}>
            <img css={{margin: '28px 0 16px'}} width={24} src={CheckSuccessIcon} />
            <p
              css={{
                fontSize: fontSize.h3,
                fontWeight: fontWeight.thick,
                marginBottom: '16px',
              }}>
              Message sent!
            </p>
          </div>
        ),
        background: false,
        description: 'Your participants will now see this message when they open the app.',
        popupSize: PopupSize.Small,
        buttonContent: 'Done',
        handleClosePopup: closeAction,
        mainFunction: closeAction,
        zIndex,
      }}>
      <>
        <p
          css={{
            fontWeight: fontWeight.thick,
            marginBottom: '10px',
          }}>
          {messageTitle}
        </p>
        <p
          css={{
            fontSize: fontSize.h6,
          }}>
          {messageContent}
        </p>
      </>
    </PopupTemplate>
  )
}
